/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { LoadingState } from "@microsoft/shifts-models-view";
import { mutatorAction } from "satcheljs";

import { CreateActionsBaseParams } from "../CreateActionsBaseParams";

import { SingleEntityActions } from "./SingleEntityActions";
import { SingleEntityState } from "./SingleEntityState";

/**
 * Creates single entity actions.
 * @param params The parameters.
 * @returns The created actions.
 */
export function createSingleEntityActions<TEntity, TState extends SingleEntityState<TEntity>>(params: CreateActionsBaseParams<TState>): SingleEntityActions<TEntity> {
    const { namespace, store } = params;

    return {
        loadFailed: mutatorAction(`${namespace}LoadFailed`, (error: Error) => {
            store().error = error;
            store().loadingState = LoadingState.Failed;
        }),

        loadStarted: mutatorAction(`${namespace}LoadStarted`, () => {
            store().error = undefined;
            store().loadingState = LoadingState.Loading;
        }),

        loadSucceed: mutatorAction(`${namespace}LoadSucceed`, (value: TEntity) => {
            store().loadingState = LoadingState.Succeed;
            store().value = value;
        })
    };
}
